import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { UserProvider } from './context/UserContext';
import { HelmetProvider, Helmet } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <UserProvider>
      <HelmetProvider>
        
        {/* SEO GLOBAL (fallback uniquement) */}
        <Helmet>
          <title>ServicePro – Trouvez un Artisan en Tunisie</title>

          <meta name="description" content="Trouvez un plombier, électricien ou artisan en Tunisie rapidement." />
          <meta name="robots" content="index, follow" />
          
          <link rel="canonical" href="https://www.servicepro.tn/" />

          {/* Open Graph default */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="ServicePro Tunisie" />
          <meta property="og:description" content="Plateforme de services en Tunisie" />
          <meta property="og:url" content="https://www.servicepro.tn/" />
          <meta property="og:image" content="https://www.servicepro.tn/og-image.jpg" />
        </Helmet>

        <App />

      </HelmetProvider>
    </UserProvider>
  </React.StrictMode>
);
